<script lang="ts" setup>
definePageMeta({
  layout: "site",
});
</script>

<template>
  <div class="relative bg-background">
    <!-- Modern Hero Section with Glass Effect & Floating Elements -->
    <ModernHero />

    <!-- Product Showcase with Alternating Layouts (Vercel-inspired) -->
    <ModernShowcase />

    <!-- Features Section with Hover Effects (Notion-inspired) -->
    <ModernFeatures />

    <!-- Integrations & Testimonials (GitHub-inspired) -->
    <ModernIntegrations />

    <!-- Modern Pricing with Enhanced Cards -->
    <ModernPricing />

    <!-- Support Section -->
    <Support />

    <!-- Footer -->
    <Footer />
  </div>
</template>

<style scoped></style>
